/**
 * external dependencies
 */
import { TabulatorFull } from 'tabulator-tables';

/**
 * Downloads the card list data as a csv file.
 * 
 * @param tableObject the table class instance containing the card list data
 * 
 * @returns void
 */
export const downloadCardListData = ( tableObject: TabulatorFull ): void => {
  const tableDownload = document.querySelector('#download-card-list-csv') as HTMLElement;
  const fileName = `cardlist_${new Date().toLocaleDateString()}_download.csv`;

  tableDownload.addEventListener('click', () => tableObject.download('csv', fileName));
};